/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import { Checkbox, InputAdornment, TextField, Tooltip } from "@material-ui/core";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { Autocomplete } from "@material-ui/lab";
import { CONFIG_TOOL_TIPS } from "../../../../utility/toolTipMessages";
import { AGENT_CONNECT_STATES } from "../../../../utility/constants";

const PACEToTeamsStatusMapper = ({ selectedStatuses, onChange, setFormEdited, validationError }) => {
	const helperText = validationError ? "Please select at least one PACE Agent state to sync" : "";
	return (
		<Autocomplete
			multiple
			disableCloseOnSelect
			options={Object.keys(AGENT_CONNECT_STATES)}
			getOptionSelected={(option, value) => option === value}
			getOptionLabel={(option) => AGENT_CONNECT_STATES[option]}
			defaultValue={selectedStatuses || []}
			value={selectedStatuses}
			onChange={(_event, newValue) => {
				onChange("connectStatuses", newValue);
				setFormEdited(true);
			}}
			renderOption={(option, { selected }) => (
				<React.Fragment>
					<Checkbox
						icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
						checkedIcon={<CheckBoxIcon fontSize="small" />}
						style={{ marginRight: 8 }}
						checked={selected}
					/>
					{AGENT_CONNECT_STATES[option]}
				</React.Fragment>
			)}
			renderInput={(params) => (
				<TextField
					{...params}
					label="PACE Agent States to Teams Busy Status"
					placeholder={
						selectedStatuses?.length !== Object.keys(AGENT_CONNECT_STATES).length
							? "Select one or more statuses"
							: undefined
					}
					style={{ minWidth: "40%" }}
					InputLabelProps={{
						shrink: true,
					}}
					error={validationError}
					helperText={helperText}
					InputProps={{
						...params.InputProps,
						style: {
							minHeight: 32,
						},
						startAdornment: (
							<>
								<InputAdornment position="start">
									<Tooltip
										arrow
										interactive
										placement={"bottom-start"}
										title={CONFIG_TOOL_TIPS.AWS_CONNECT_TO_TEAMS_OFFLINE_STATUS}
									>
										<i style={{ height: "15px", color: "gray" }} className="fas fa-info-circle" />
									</Tooltip>
								</InputAdornment>
								{params.InputProps.startAdornment}
							</>
						),
					}}
				/>
			)}
		/>
	);
};

export default PACEToTeamsStatusMapper;
